import {INPUT_RULES} from '@/configs/dailyReport';
export default class DailyReportControlRules {
  constructor () {
  }
  getAllControlRules(workOrderType, zzOwn, vendorSiteSelect) {
    console.log('getAllControlRules', workOrderType, zzOwn, vendorSiteSelect);
    return INPUT_RULES.find(x => x.work_order_type === workOrderType && x.zz_own === zzOwn && x.vendor_site === vendorSiteSelect);
  }
}
